<button
  (click)="_.changeSelected(value); clicked.next(undefined!)"
  [class.active]="_.selected && active"
>
  <div class="label">
    {{ text }}
  </div>
</button>
